<template>
    <div id="content" class="sub">
        <div class="grid--con-sub">
            <template v-if="mode == 'list'">
                <div class="board-list">
                    <ul v-if="list.qstnList.length > 0">
                        <li v-for="(qstnInfo, index) in list.qstnList" :key="'qstnInfo_'+index" @click="showQstnView(qstnInfo)">
                            <a href="javascript:;">
                                <div class="board-tit-con">
                                    <div class="entry-tag">
                                        <span :class="getSttusClass('list', qstnInfo.sttus)">{{qstnInfo.sttusNm}}</span>
                                    </div>
                                    <div class="entry-title"><span>[{{qstnInfo.clCdNm}}]</span> {{qstnInfo.sj}}</div>
                                    <div class="entry-date">{{qstnInfo.qstnDt.substr(0, 10)}}</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul v-if="list.qstnList.length == 0">
                        <li>
                            <a href="javascript:;">
                                <div class="board-tit-con">
                                    <div class="entry-title">1:1문의내역이 없습니다. 문의하기 버튼을 눌러 문의해주세요.</div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <pagenavi :paginginfo="paginginfo" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
                <div class="btn-wrap f-oh __right mgt30">
                    <button class="middle _bt-navy" @click="writeQstn()">문의하기<div class="img-com _bt-ic05"><span>문의하기 아이콘</span></div></button>
                </div>
            </template>

            <template v-if="mode == 'write'">
                <div class="grid--form" style="width: 800px;">
                    <table class="tb-none">
                        <colgroup>
                            <col style="width:25%;" />
                            <col style="width:*;" />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>제목</th>
                            <td>
                                <select style="width:25% !important;" v-model="write.qstnInfo.clCd" @change="changeClcd()">
                                    <option v-for="(cdInfo, index) in write.clcdList" :value="cdInfo.cd" :key="'cdInfo_'+index">{{cdInfo.cdNm}}</option>
                                </select>
                                <input ref="sj" type="text" class="mgl5" style="width:calc( 75% - 9px ) !important;" maxlength="80" v-model="write.qstnInfo.sj"/>
                            </td>
                        </tr>
                        <tr>
                            <th>내용</th>
                            <td>
                                <editor ref="faqEditor"
                                        :editorid="1"
                                        :cn="write.qstnInfo.cn"
                                        :setstorge="'qstn/' + mberInfo.mberNo + '/answer/' + dayInfo.ymd + '/'"
                                        :setbasepath="setBasePath"
                                        :cnimgtagfunc="setCnImgTag">
                                </editor>
                            </td>
                        </tr>
                        <tr>
                            <th>첨부파일</th>
                            <td>
                                <fileupload ref="fileList"
                                            :formse="'dragAndBtn'"
                                            :filelist="write.qstnInfo.fileList"
                                            :maxcnt="5"
                                            :maxsize="10"
                                            :extsns="'gif,jpg,doc,xls,ppt,pdf,txt,xlsx,png,pptx,docx,jpeg,zip,hwp,bmp'"
                                            :cdn-at="'Y'"
                                            :setbasepath="'oncs/'"
                                            :setstorge="'portal/i5gam/qstn/' + mberInfo.mberNo + '/' + dayInfo.ymd + '/'">
                                </fileupload>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btn-wrap __center mgt40">
                    <button class="big _bt-white" @click="showQstnList()"><span>취소</span></button>
                    <button class="big _bt-ypurple" @click="saveQstn()"><span>저장</span></button>
                </div>
            </template>

            <template v-if="mode == 'view'">
                <div class="board-view box-type04">
                    <div class="section-title">
                        <div class="board-tit-con">
                            <div class="entry-tag inquiry">
                                <span :class="getSttusClass('view', view.qstnInfo.sttus)">{{view.qstnInfo.sttusNm}}</span>
                            </div>
                            <div class="entry-title"><span>[{{view.qstnInfo.clCdNm}}]</span> {{view.qstnInfo.sj}}</div>
                            <div class="entry-date">{{view.qstnInfo.substr}}</div>
                        </div>
                    </div>
                    <div class="section-file" v-if="view.qstnInfo.fileList.length > 0">
                        <div class="file-att-list">
                            <ul>
                                <li v-for="(fileInfo, index) in view.qstnInfo.fileList" :key="'fileInfo_'+index">
                                    <a href="javascript:;" @click="downloadFile(fileInfo)">
                                        <div class="img-com" :class="$onbiLib.bindFileIconClass(fileInfo.extsn)"><span>{{fileInfo.extsn}}</span></div>{{fileInfo.orginlNm}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="board-view-con" v-html="view.qstnInfo.qstn"></div>
                    <div class="board-view-bt-box">
                        <div class="board-view-bt">
                            <div class="entry-title"><div class="img-com __icon05"><span>답변 아이콘</span></div>답변</div>
                            <div class="entry-con" v-html="view.qstnInfo.answer"></div>
                        </div>
                    </div>
                </div>
                <div class="btn-wrap __right mgt30">
                    <button class="middle _bt-ypurple" @click="showQstnList()"><span>목록으로</span></button>
                    <button class="btn-w75 middle _bt-gray" @click="deleteQstn()"><span>삭제</span></button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    const mixinWrite = {
        data: function(){
            return {
                setBasePath:'/upload/',
                write: {
                    qstnInfo : new Array(),
                    clcdList : new Array(),
                },
            }
        },
        methods : {
            changeClcd : function(){
                console.log(this.write.qstnInfo.cn);
                var cn = '';
                //세금계산서 재발행인 경우 내용에 기본으로 셋팅
                if(this.write.qstnInfo.clCd == 'C05'){
                    cn = "4. 결제금액 : <br/> 3. 결제일 : <br/> 2. 사업자번호 : <br/> 1. 어린이집명 : ";
                    window.Editor.getCanvas().pasteContent(cn);
                }else{
                    window.Editor.getCanvas().initContent(cn);
                }
            },
            setCnImgTag:function(fileInfo,id){
                var imgUrl = this.$onbiLib.getImageFileUrl(fileInfo.fileSe,fileInfo.fileNm,fileInfo.storge,fileInfo.extsn,this.setBasePath);
                var imgTag = '<img src="'+ imgUrl + '" ';

                var contentWid = document.getElementById(id).offsetWidth - 30;
                if(fileInfo.imgWid > contentWid){
                    imgTag += 'style="width:' + contentWid + 'px;"';
                }
                imgTag += '/>';

                return imgTag;
            },
            saveQstn : function(){
                this.write.qstnInfo.cn = window.Editor.getContent();
			
                if(this.validCheck()){
                    return false;
                }

                const _this = this;
                this.axios.post('/i5gam/cs/qstn/saveQstnInfo.act',{
                    fcltcd : '0',
                    mberNo : this.mberInfo.mberNo,
                    qstnInfo : this.write.qstnInfo,
                    fileList : this.write.qstnInfo.fileList
                }).then(function(response) {
                    const insertProc = response.data.insertProc;
                    if(insertProc == 'Y'){
                        this.$toasted.show(this.$onbiLib.msg.suc.save, {duration:1000, type:'success'});
                        this.paginginfo.curPageNum = 1;
                        this.showQstnList();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            validCheck : function() {//일대일 문의 새로 작성 저장
                if(this.write.qstnInfo.clCd == ""){
                    this.$toasted.show('구분을 선택해주십시오.');
                    return true;
                }
                
                if(this.write.qstnInfo.sj.trim() ==""){
                    this.$toasted.show('제목을 작성해주십시오.');
                    this.$refs.sj.focus();
                    return true;
                }

                if(this.write.qstnInfo.cn.trim() == "<p><br></p>"){
                    this.$toasted.show('내용을 작성해주십시오.');
                    return true;
                }

                return false;
            },
        }
    }

    const mixinView = {
        data : function(){
            return {
                view : {
                    qstnInfo : new Array(),
                },
            }
        },
        methods : {
            deleteQstn : function(){
                if(!confirm("삭제하시겠습니까?")){
                    return;
                }

                const _this = this;
                this.axios.post('/i5gam/cs/qstn/deleteQstnInfo.act',{
                    srvcCd : this.srvcCd,
                    fcltcd : '0',
                    mberNo : this.mberInfo.mberNo,
                    sn : this.view.qstnInfo.sn
                }).then(function(response) {
                    if(response.data.deleteProc == 'Y'){
                        this.$toasted.show(this.$onbiLib.msg.suc.del, {duration:1000, type:'success'});
                        this.showQstnList();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            downloadFile : function(fileInfo){
                const _this = this;
                if(this.$onbiLib.chkCdnAt(fileInfo)){
                    _this.$onbiLib.getAuthKey().then(function(authKey){
                        _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo,encodeURIComponent(authKey));
                    });
                }else{
                    const params = 'sn='+this.view.qstnInfo.sn+'&fgrpCd='+fileInfo.fgrpCd+'&fileCd='+fileInfo.fileCd;
                    this.$onbiLib.setFileDownLoadUrl('/i5gam/cs/qstn/qstnFileDownLoad.act', params);
                }
            }
        }
    }

    const mixinList = {
        data : function(){
            return {
                list : {
                    qstnList : new Array(),
                },
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 15, /* 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지당 게시물수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFunc:null
                },
            }
        },
        methods : {
            showQstnView : function(qstnInfo){
                const _this = this;

                this.axios.post('/i5gam/cs/qstn/searchQstnDetailInfo.act',{
                    srvcCd : 'SBIP02',
                    fcltcd : '0',
                    mberNo : this.mberInfo.mberNo,
                    sn : qstnInfo.sn
                }).then(function(response) {
                    const qstnInfo = response.data.qstnInfo;
                    this.view.qstnInfo = qstnInfo.qstnDetailInfo;
                    this.view.qstnInfo.fileList = qstnInfo.qstnFileList;
                    this.mode = 'view';
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
                window.scrollTo(0, 0);
            }
        }
    }

    export default {
        name : 'qstn',
        mixins : [mixinList, mixinWrite, mixinView],
        data : function(){
            return {
                mode : '',
                srvcCd : 'SBIP02',
                csTabList : [
                    {tabNm : '공지사항', uri : 'views.i5gam.cs.notice'},
                    {tabNm : 'FAQ', uri : 'views.i5gam.cs.faq'},
                    {tabNm : '1:1 문의', uri : 'views.i5gam.cs.qstn'},
                    {tabNm : '원격지원', uri : 'views.i5gam.cs.remoteSupport'},
                ],
                defQstnInfo : {
                    srvcCd : 'SBIP02',
                    clCd : '',
                    sj : '',
                    cn : '',
                    fileList : new Array(),
                }
            }
        },
        computed : {
            dayInfo: function(){
                return this.$store.getters.getDayInfo;
            },
            mberInfo : function(){
                return this.$store.getters.getMberInfo;
            },
        },
        methods : {
            init : function(){
                this.paginginfo.callBackFunc = this.searchQstnList;
                this.mode = 'list';

                this.$nextTick(function(){
                    this.searchQstnList();
                })
            },
            searchQstnList : function(){
                const _this = this;
                this.axios.post('/i5gam/cs/qstn/searchQstnList.act',{
                    pagingInfo : {
                        curPageNum : this.paginginfo.curPageNum,
                        startCnt : ((this.paginginfo.curPageNum-1) * this.paginginfo.pageListCnt)+1,
                        endCnt : this.paginginfo.curPageNum * this.paginginfo.pageListCnt,
                        srvcCd : this.srvcCd,
                        mberNo : this.mberInfo.mberNo,
                        fcltcd : '0'
                    },
                }).then(function(response) {
                    const qstnInfo = response.data.qstnInfo;

                    this.list.qstnList = qstnInfo.qstnList;
                    this.paginginfo.totCnt = qstnInfo.pagingInfo.totCnt;
                    this.paginginfo.curPageNum = qstnInfo.pagingInfo.curPageNum;

                    window.scrollTo(0, 0);
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                    window.scrollTo(0, 0);
                });
            },
            writeQstn : function(){
                this.write.qstnInfo = JSON.parse(JSON.stringify(this.defQstnInfo));
                this.mode = 'write';
                window.scrollTo(0, 0);
            },
            showQstnList : function(){
                this.mode = 'list';
                this.searchQstnList();
                window.scrollTo(0, 0);
            },
            getSttusClass : function(txt, sttus){//sttus 클래스 가져오기
                var val = '';
                
                if(sttus != '' && sttus != null){
                    if(sttus == 'N00'){
                        val = "tag01";
                    }else if(sttus == 'N01'){
                        val = "tag01";
                    }else if(sttus == 'N02'){
                        val = "tag03";
                    }else if(sttus == 'N03'){
                        val = "tag03";
                    }else{
                        val = "tag02";
                    }
                    
                    if(txt == 'list') val += ' inquiry';
                }
                
                return val;
            },
        },
        mounted : function(){
            const _this = this;
            const searchInfo = {cdGrp : 'CNS'};
            this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeInfo){
                _this.write.clcdList = codeInfo;
                _this.write.clcdList.splice(0, 0, {cd : '', cdNm : '선택'});
                _this.init();
            });
        }
    }
</script>